module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-8.28b55d7d.png";